export default __webpack_public_path__ + "static/media/eco.67dd6373.jpg";